import { MovementType } from "@/domain/accounts/account"

export const RenderAmount = ({ amount, movementType }: { amount: number, movementType: MovementType }) =>
  <span className={`price-format font-mono font-medium ${MovementType.Credit === movementType ? 'text-green-600' : 'text-red-600'}`}>
    {amount?.toLocaleString('es-AR')}
  </span>

export const RenderBalance = ({ balance }: { balance: number }) =>
  <span className='text-xs font-medium text-muted-foreground bg-muted px-2 py-0.5 rounded-md'>
    {balance === 0 ? '' : balance > 0 ? '$ ' : '- $'}{Math.abs(balance)?.toLocaleString('es-AR')}
  </span>

export const RenderBalanceInColor = ({ balance }: { balance: number }) =>
  <span className={`font-bold ${balance === 0 ? 'text-muted-foreground' : balance > 0 ? 'text-green-600' : 'text-red-600'}`}>
    {balance === 0 ? '$' : balance > 0 ? '$ ' : '- $'}{Math.abs(balance)?.toLocaleString('es-AR')}
  </span>